import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { FormErrorMessage } from '@companydotcom/potion';
import { ErrorMessage } from '@hookform/error-message';
export const TranslationErrorMessage = props => {
    const { t } = useTranslation();
    return (_jsx(ErrorMessage, Object.assign({}, props, { render: ({ message }) => _jsx(FormErrorMessage, { children: t(message) }, void 0) }), void 0));
};
